var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"items":_vm.federations,"small-chips":"","dense":"","outlined":"","label":_vm.$t('message.pick_add_federation')},on:{"input":event => { _vm.$emit('input', event) }},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }